<!-- eslint-disable -->
<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Редактирование категории</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <div v-else>
                            <label>Изображение категории</label>

                            <div class="mb-3 mt-3">
                                <b-img v-if="category.image" :src="$urlBackEnd(category.image)" fluid alt="Responsive image"></b-img>
                            </div>

                            <button @click="deleteImage" v-if="category.image" class="btn btn-danger btn-sm mb-4">Удалить изображение</button>


                            <vue-dropzone ref="myVueDropzone"
                                          id="dropzone"
                                          :options="dropzoneOptions"
                                          :useCustomSlot=true
                                          v-on:vdropzone-success="successDrop"
                                          v-on:vdropzone-max-files-exceeded="maxDrop"
                            >
                                <div class="dropzone-custom-content">
                                    <b class="dropzone-custom-title">Выберите файл</b>
                                    <div class="subtitle">...или перетащите его сюда</div>
                                </div>
                            </vue-dropzone>

                            <label class="mt-5">Иконка категории</label>

                            <div class="icon mt-4">
                                <img v-if="category.icon" :src="$urlBackEnd(category.icon)" alt="icon">
                            </div>


                            <div class="icon-category">
                                <vue-dropzone ref="myVueDropzoneIcon"
                                              id="dropzoneIcon"
                                              :options="dropzoneOptionsIcon"
                                              :useCustomSlot=true
                                              v-on:vdropzone-success="successDropIcon"
                                              v-on:vdropzone-max-files-exceeded="maxDrop"
                                >
                                    <div class="dropzone-custom-content">
                                        <b class="dropzone-custom-title">Выберите иконку</b>
                                    </div>
                                </vue-dropzone>
                            </div>


                            <b-form-group class="mt-5"
                                          description="Введите заголовок категории"
                                          label="Заголовок:"
                            >
                                <b-form-input
                                        v-model.trim="category.name"
                                        :class="{'is-invalid': errors.name}"
                                        required
                                ></b-form-input>
                                <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                            </b-form-group>

                            <b-form-group class="mt-0" description="Введите url категории или нажмите кнопку *Сформировать" label="url категории:">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button @click="getCode" v-b-tooltip.hover title="Сформировать url адрес страницы категории на основе заголовка" ref="get_category_url" class="btn btn-primary" type="button">Сформировать</button>
                                    </div>
                                    <b-form-input v-model.trim="category.code" :class="{'is-invalid': errors.code}"></b-form-input>
                                    <div v-if="errors.code" class="invalid-feedback">{{errors.code[0]}}</div>
                                </div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          description="Введите описание категории"
                                          label="Описание:"

                            >
                                <b-form-textarea
                                        id="description"
                                        v-model.trim="category.description"
                                        :class="{'is-invalid': errors.description}"
                                ></b-form-textarea>
                                <div v-if="errors.description" class="invalid-feedback">{{errors.description[0]}}</div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          description="Данная категория является родительской - изменения невозможны"
                                          label="Родительская категория:"
                            >
<!--                                <b-form-select v-model="subcategory" class="mb-3">-->
<!--                                    <option :value="null">Нет</option>-->
<!--                                    <template v-for="(category, i) in category.categories" >-->
<!--                                    <option v-bind:key="i" :value="category.id">{{category.name}}</option>-->
<!--                                    </template>-->
<!--                                </b-form-select>-->

                            </b-form-group>

                            <b-form-group class="mt-3"
                                          description="Список дочерних категории"
                                          label="Подкатегории:"
                            >
                            <b-list-group>
                                <template v-for="(children) in category.children_categories" >
                                <b-list-group-item>{{children.name}}</b-list-group-item>
                                </template>
                            </b-list-group>
                            </b-form-group>

                            <div class="d-flex justify-content-between">
                                <b-button @click="saveCategory" ref="add_category" variant="primary">Сохранить</b-button>
                                <b-button @click="showModal" ref="delete_product" type="submit" variant="outline-danger">Удалить категорию</b-button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">

            <div>
            <div class="d-block text-center">
                <h3>Удалить категорию: {{category.name}}?</h3>
                <p>У категории могут иметься дочернии категории и товары</p>
            </div>

            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteCategory">Удалить</b-button>
                </b-col>
            </b-row>

            </div>

        </b-modal>

    </div>

</template>

<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        GET_CATEGORY,
        UPDATE_CATEGORY,
        DELETE_CATEGORY
    } from "@/core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {GET_TRANSLATE} from "../../../core/services/store/products.module";

    export default {
        name: "EditCategory",
        components: {
            vueDropzone: vue2Dropzone
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Категории", route: "/categories" },
                { title: "Редактировать категорию" }
            ]);
            this.$store.dispatch(GET_CATEGORY, this.$route.params.id)
        },

        computed: {
            ...mapGetters({
                category: 'gettersCategory',
                errors: 'errorsCategory',
                load: 'getCategoryLoad'
            }),

            // subcategory: this.category.children_categories[0].id

        },

        data() {
            return {

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/categories/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

                dropzoneOptionsIcon: {
                    url: this.$urlBackEnd('/api/v1/categories/icon'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                }


            }
        },

        methods:{
            saveCategory(){
                const submitButton = this.$refs["add_category"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const id = this.category.id;

                const category = {
                    name: this.category.name,
                    code: this.category.code,
                    description: this.category.description,
                    image: this.category.image,
                    icon: this.category.icon
                };


                // const subcategory = this.subcategory;

                this.$store.dispatch(UPDATE_CATEGORY, {id, category })
                    .then(() => {
                        this.showAlert('Категория успешно сохранена', 'success');
                        this.$router.push({ name: "Categories" })
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            async getCode(){

                const submitButtonUrl = this.$refs["get_category_url"];
                submitButtonUrl.classList.add("spinner", "spinner-light", "spinner-right");

                try {
                    const data = await this.$store.dispatch(GET_TRANSLATE, {title: this.category.name});
                    this.category.code = data.code;
                    this.showAlert('URL адрес успешно сформирован ', 'success', 'toast');
                } catch (response) {
                    if (response.status === 422){
                        this.showAlert('Введите название категории', 'danger', 'toast');
                    } else {
                        this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    }
                } finally {
                    submitButtonUrl.classList.remove("spinner", "spinner-light", "spinner-right")
                }
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.category.image = response.original;
            },


            successDropIcon (file, response) {
                this.$refs.myVueDropzoneIcon.removeAllFiles();
                this.category.icon = response.original;
            },

            maxDrop (){
                this.showAlert('Не более одного файла', 'danger', 'toast');
            },

            deleteImage(){
                this.category.image = null;
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            showModal() {
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.$refs['delete-modal'].hide()
            },

            deleteCategory(){
                this.hideModal();
                this.$store.dispatch(DELETE_CATEGORY, this.category.id)
                    .then(() => {
                        this.showAlert('Категория успешно удалена', 'success');
                        this.$router.push({ name: "Categories" })
                    })
                    .catch(() => {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    })
            }
        }
    }
</script>

<style>
    .icon-category .dropzone{

        min-height: auto;
        padding: 5px 5px;
        background: #f0f0f0;
        border: none;
    }

    .icon-category{
        margin: 10px 0 10px 0;
        height: 50px;
        width: 100px;

    }

    .icon-category .dropzone .dz-message{
        margin: 5px;
    }
</style>
